export type {
  ConnectorSourceJourneysObjectMapping,
  MessageMetricsSourceSettings,
  Schema,
  SchemaEvent,
  Source,
  SourceApiKey,
  SourceEvent,
  SourceMetrics,
} from '@/services/db/cdp-source/entity';
export type {
  AvailableSource,
  IntegrationMetadataItem,
  IntegrationMetadataLink,
  SourceSyncTemplate,
} from '@/services/db/cdp-source-option/entity';
export type {
  ConnectorSourceRecord,
  ConnectorSourceRecordField,
  ConnectorSourceRecordMapping,
  ConnectorSourceStreamConfig,
  CreateOrUpdateSourceSyncCmd,
  SourceSync,
  SourceSyncRun,
} from '@/services/db/cdp-source-sync/entity';
export { ConnectorSourceTransformationType } from '@/services/db/cdp-source-sync/entity';

export const SourceType = {
  CONNECTOR: 'connector',
  DATABASE: 'database',
} as const;
type SourceType = (typeof SourceType)[keyof typeof SourceType];
